import { equals, not } from 'ramda';
import { ONE } from 'src/services/constants';

/**
 * isIndexIsTrue - whether the given index number is true or not true,
 * i.e. it checks index value is -1 or nor
 * @param index - icontains whose index number is to be checked
 * @returns whether found index is true,that is its not -1
 */
export const isIndexIsTrue = (index: number) => not(equals(index, -ONE));
